import React, {useContext} from "react";
import PropTypes from "prop-types";
import {buyNowContext} from "../BuyNow";

const LineItemDisplay = ({ lineItem, textClass }) => {
  const { quantitiesEnabled } = useContext(buyNowContext);
  let description;
  const originalUnitPrice = lineItem.product.price;
  const discountedUnitPrice = lineItem.unitPrice;

  const formatPrice = price => {
    const numericPrice = Number(price);
    const roundedPrice = Math.round(numericPrice);

    // The price is something like 99.0
    if (numericPrice === roundedPrice)
      return roundedPrice;

    // The price is something like 4.99
    return numericPrice;
  };

  // We want to show a different description of the line item depending on whether quantities are enabled.
  // If enabled, we want to show some individual product pricing information.
  // If not enabled, we want to show a text description.
  if (quantitiesEnabled) {
    if (originalUnitPrice - discountedUnitPrice > 1) {
      description = <p className="sub-txt text-muted text-capitalize">
        <span style={{ textDecoration: "line-through", color: "red", marginRight: "10px" }}>{`$${formatPrice(originalUnitPrice)}`}</span>
        <span>{`$${formatPrice(discountedUnitPrice)}`}</span>
      </p>;
    }
    else
      description = <p className="sub-txt text-muted text-capitalize">{`$${formatPrice(originalUnitPrice)}`}</p>;
  }
  else {
    description = <p className="sub-txt text-muted text-capitalize">{lineItem.product.lineItemDescription}</p>;
  }

  return (
    <div className="row justify-content-between">
      <div className="col-6 d-flex flex-column">
        <p className={textClass}>{lineItem.product.lineItemName}</p>
        {description}
      </div>
      <div className="col-2 text-center">
        {quantitiesEnabled && <p className={textClass}>{lineItem.quantity}</p>}
      </div>
      <div className="col-4 text-end">
        <p className={textClass}>${lineItem.price.toFixed(2)}</p>
      </div>
    </div>
  );
};

LineItemDisplay.defaultProps = {
  textClass: ""
};

LineItemDisplay.propTypes = {
  lineItem: PropTypes.object.isRequired,
  textClass: PropTypes.string
};

export default LineItemDisplay;